// extracted by mini-css-extract-plugin
export default {"textContainer":"CampaignHeaderStatusBanner_textContainer__0Ry0c"};